import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"
import DateFnsUtils from "@date-io/date-fns"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import Fab from '@material-ui/core/Fab'
import TextField from '@material-ui/core/TextField'
// import Button from '@material-ui/core/Button'

// Material-UI Element
import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Material-UI Icon
import FindInPageIcon from '@material-ui/icons/FindInPage'
import ClearIcon from '@material-ui/icons/Clear'

// Custom Component
// import useLoading from "../Loading/useLoading"
// import Legend from '../Legend/Legend'
// import ConfirmDialog from '../Dialog/ConfirmDialog'
// import SaveWarnDialog from '../Dialog/SaveWarnDialog'
// import FullScreenDialog from "../Dialog/FullScreenDialog"
// import NormalDialog from '../Dialog/NormalDialog'
// import RecipientChip from '../Chip/RecipientChip'
// import CirculationRecipientForm from './CirculationRecipientForm'
// import FileDropzone from '../FileDropzone/FileDropzone'
// import CirculationFileZoneContent from './CirculationFileZoneContent'
// import FilePreview from '../FilePreview/FilePreview'

// Custom Style
// import {oceanBlueColor, grayColor, redColor} from '../../styles/jss/cmsMainStyle'
import {circulationSearchFormStyle} from '../../styles/jss/components/circulation/circulationSearchFormStyle'

// Global Function

// Fetch Data


const useStyles = makeStyles(theme => circulationSearchFormStyle(theme))

const CirculationSearchForm = props => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const {searchAction, searchParameter, setSearchParameter, resetContent, searchLoading} = props

	// const [searchParameter, setSearchParameter] = useState({
	// 	code: "",
	// 	sname: "",
	// 	subject: "",
	// 	sdfrom: null,
	// 	sdto: null,
	// })


	// Loading 
	// const [getCircSearchLoading, getCircSearchShowLoading, getCircSearchHiddenLoading] = useLoading()


	const handleTextChange = event => {
		const {name, value} = event.target
		const res = {...searchParameter}
		res[name] = value

		setSearchParameter(res)
	}

	const handleSenderDateChange = (date, name) => {
		const res = {...searchParameter}
		res[name] = date ? date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() : null

		setSearchParameter(res)
	}


	const circulationSearchAction = () => {
		resetContent(null)
		searchAction(searchParameter, true)
	}

	const clearAction = () => {
		resetContent(null)

		setSearchParameter({
			code: "",
			sname: "",
			subject: "",
			sdfrom: null,
			sdto: null,
		})

		searchAction({
			code: "",
			sname: "",
			subject: "",
			sdfrom: null,
			sdto: null,
		})
	}



	useEffect(() => {

	}, [])


	return (
		// console.log("Search Parameter | Variable: searchParameter (CirculationSearchForm.js)"),
		// console.log(searchParameter),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<Grid container spacing={2} className={classes.content}>
				<Grid item xs={12} sm={12} lg={12}>
					<TextField
						id="code"
						name="code"
						label="Circulation Code"
						fullWidth={true}
						size="small"
						variant="outlined"
						value={searchParameter ? searchParameter.code : ""}
						onChange={handleTextChange}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</Grid>

				<Grid item xs={12} sm={12} lg={12}>
					<TextField
						id="subject"
						name="subject"
						label="Subject"
						fullWidth={true}
						size="small"
						variant="outlined"
						value={searchParameter ? searchParameter.subject : ""}
						onChange={handleTextChange}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</Grid>

				<Grid item xs={12} sm={12} lg={12}>
					<TextField
						id="sname"
						name="sname"
						label="Sender"
						fullWidth={true}
						size="small"
						variant="outlined"
						value={searchParameter ? searchParameter.sname : ""}
						onChange={handleTextChange}
						InputLabelProps={{
							shrink: true,
						}}
					/>
				</Grid>

				<Grid item xs={6} sm={6} lg={6}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<KeyboardDatePicker
							id="sdfrom"
							name="sdfrom"
							label="Send Date (From)"
							format="dd/MM/yyyy"
							placeholder="DD/MM/YYYY"
							size="small"
							inputVariant="outlined"
							value={searchParameter.sdfrom || null}
							onChange={date => handleSenderDateChange(date, "sdfrom")}
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							InputLabelProps={{
								shrink: true,
							}}
							className={classes.datePickerField}
						/>
					</MuiPickersUtilsProvider>
				</Grid>

				<Grid item xs={6} sm={6} lg={6}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<KeyboardDatePicker
							id="sdto"
							name="sdto"
							label="Send Date (To)"
							format="dd/MM/yyyy"
							placeholder="DD/MM/YYYY"
							size="small"
							inputVariant="outlined"
							value={searchParameter.sdto || null}
							onChange={date => handleSenderDateChange(date, "sdto")}
							KeyboardButtonProps={{
								"aria-label": "change date"
							}}
							InputLabelProps={{
								shrink: true,
							}}
							className={classes.datePickerField}						
						/>
					</MuiPickersUtilsProvider>
				</Grid>

				<Grid item xs={4} sm={4} lg={4} className={classes.toolBar}>
					<Tooltip title="Search">
						<Fab 
							aria-label="search"
							color="primary"
							size="small"
							onClick={circulationSearchAction}
							className={classes.toolMenuBarBtn}
						>
							<FindInPageIcon />
						</Fab>
					</Tooltip>
				</Grid>

				<Grid item xs={4} sm={4} lg={4} className={classes.toolBar}>
					{searchLoading}
				</Grid>

				<Grid item xs={4} sm={4} lg={4} className={classes.toolBar}>
					<Tooltip title="Clear All">
						<Fab 
							aria-label="clear"
							color="primary"
							size="small"
							onClick={clearAction}
							className={classes.toolMenuBarBtn}
						>
							<ClearIcon />
						</Fab>
					</Tooltip>
				</Grid>

				{/* <Grid item xs={12} sm={12} lg={12} className={classes.toolBar}>
					<Tooltip title="Search">
						<Fab 
							aria-label="search"
							color="primary"
							size="small"
							onClick={circulationSearchAction}
							className={classes.toolMenuBarBtn}
						>
							<FindInPageIcon />
						</Fab>
					</Tooltip>

					{searchLoading}

					<Tooltip title="Clear All">
						<Fab 
							aria-label="clear"
							color="primary"
							size="small"
							onClick={clearAction}
							className={classes.toolMenuBarBtn}
						>
							<ClearIcon />
						</Fab>
					</Tooltip>
				</Grid> */}


			</Grid>

		</Fragment>
	)
}


export default CirculationSearchForm